exports.components = {
  "component---src-pages-calculadora-macros-js": () => import("./../../../src/pages/calculadora-macros.js" /* webpackChunkName: "component---src-pages-calculadora-macros-js" */),
  "component---src-pages-form-inscricao-js": () => import("./../../../src/pages/form-inscricao.js" /* webpackChunkName: "component---src-pages-form-inscricao-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

